import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function TextCell(props) {
  const { data } = props;
  return (
    <>
      {data ? (
        <TextStyle>{data}</TextStyle>
      ) : (
        <FormattedMessage id="app.noData.message" />
      )}
    </>
  );
}

export default TextCell;
